<template>
  <main id="selecionar-empresa" class="ohx login-modal">
    <v-content class="ohx">
      <v-container fluid grid-list-xl class="white-background ohx pb-4">
        <v-layout row wrap>
          <v-flex xs12>
            <h2 class="title">Adicionar Participante</h2>
            <span class="close-button" @click.prevent="close()">
              <v-icon>close</v-icon>
            </span>
            <v-divider></v-divider>
          </v-flex>

          <v-flex xs12>
            <label class="font-weight-black caption"
              >Escolha o tipo de tomador</label
            >
          </v-flex>

          <v-btn
            v-for="(text, index) in [
              'Empresa com CNPJ',
              'Empresa Estrangeira sem CNPJ',
            ]"
            :key="index"
            class="jns-button blue-button flex"
            :class="{ active: taker.stepType == index + 1 }"
            :value="index + 1"
            @click="selectTakerType($event)"
          >
            {{ text }}
            <v-icon v-if="taker.stepType == index + 1" class
              >check_circle_alt</v-icon
            >
          </v-btn>

          <div class="flex xs12">
            <v-layout row wrap>
              <v-flex xs6 v-if="taker.stepType == 1">
                <v-flex xs12></v-flex>
                <v-text-field
                  :placeholder="'Pesquisar'"
                  :label="'Digite o CNPJ'"
                  append-icon="search"
                  @click.append="getTakerByCNPJ"
                  @keyup.enter="getTakerByCNPJ()"
                  v-model="taker.cnpj"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  class="jns-input"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>

          <div class="form-grey-box" v-if="taker.stepType == 1 && taker.info">
            <v-text-field
              class="grey-box-input mb-3"
              label="Razão Social Tomador"
              v-model="taker.info.nome"
              readonly
              placeholder=" "
            ></v-text-field>
            <v-text-field
              class="grey-box-input"
              label="Endereço"
              readonly
              v-model="takerInfoFullAddress"
              placeholder=" "
            ></v-text-field>
          </div>

          <div class="flex xs12" v-if="taker.stepType == 2">
            <v-layout
              row
              wrap
              v-if="taker.stepType == 2 && !taker.hasOwnProperty('notFound')"
            >
              <v-flex xs6>
                <v-text-field
                  class="jns-input"
                  label="Digite a Razão Social"
                  placeholder=" "
                  v-model="taker.name"
                  append-icon="search"
                  :append-icon-cb="getTakerByRazaoSocial"
                  @keyup.enter="getTakerByRazaoSocial()"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-form
              ref="taker-estrangeiro-form"
              v-model="takerFormValid"
              v-if="taker.stepType == 2 && taker.notFound"
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    class="jns-input"
                    label="Razão Social"
                    placeholder=" "
                    :rules="[rules.required]"
                    v-model="taker.name"
                  ></v-text-field>
                </v-flex>

                <v-flex xs6></v-flex>
                <v-flex xs2>
                  <v-text-field
                    :rules="[rules.required]"
                    class="jns-input"
                    v-model="taker.enderecos[0].cep"
                    v-mask="'#####-###'"
                    v-if="taker.stepType == 2 && taker.notFound"
                    label="CEP"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field
                    :rules="[rules.required]"
                    class="jns-input"
                    v-model="taker.enderecos[0].rua"
                    v-if="taker.stepType == 2 && taker.notFound"
                    label="Endereço"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    :rules="[rules.required]"
                    class="jns-input"
                    v-model="taker.enderecos[0].numero"
                    v-if="taker.stepType == 2 && taker.notFound"
                    label="Número"
                    maxlength="8"
                    @keypress="isNumberOrDash($event)"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    class="jns-input"
                    v-if="taker.stepType == 2 && taker.notFound"
                    v-model="taker.enderecos[0].complemento"
                    label="Complemento"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    :rules="[rules.required]"
                    class="jns-input"
                    v-model="taker.enderecos[0].bairro"
                    v-if="taker.stepType == 2 && taker.notFound"
                    label="Bairro"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    :rules="[rules.required]"
                    class="jns-input"
                    v-model="taker.enderecos[0].cidade"
                    v-if="taker.stepType == 2 && taker.notFound"
                    label="Cidade"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    :rules="[rules.required]"
                    class="jns-input"
                    v-model="taker.enderecos[0].uf"
                    v-if="taker.stepType == 2 && taker.notFound"
                    label="UF"
                    @keypress="isLetter($event)"
                    maxlength="2"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>

            <div class="form-grey-box" v-if="taker.stepType == 2 && taker.info">
              <span @click.prevent="unselectTaker" class="box-close-button">
                <v-icon>close</v-icon>
              </span>
              <v-text-field
                class="grey-box-input mb-3"
                label="Razão Social Tomador"
                v-model="taker.info.nome"
                readonly
                placeholder=" "
              ></v-text-field>
              <v-text-field
                class="grey-box-input"
                label="Endereço"
                readonly
                v-model="takerInfoFullAddress"
                placeholder=" "
              ></v-text-field>
            </div>

            <div
              v-if="
                taker.stepType == 2 && takerResults.length && showSelectTaker
              "
            >
              <h2>Selecionar Empresa</h2>
              <v-list two-line>
                <template v-for="(item, index) in takerResults">
                  <v-list-tile :key="item.id" ripple @click="selectTaker(item)">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <strong>{{ item.nome }}</strong>
                      </v-list-tile-title>
                      <!-- <v-list-tile-sub-title class="text--primary">{{ item.headline }}</v-list-tile-sub-title> -->
                      <v-list-tile-sub-title>{{
                        item.endereco.logradouro
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="index + 1 < takerResults.length"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list>
            </div>
          </div>

          <v-flex xs12>
            <v-spacer></v-spacer>
            <v-btn
              v-if="taker.found"
              class="jns-button width-auto yellow-button"
              @click="$emit('addParticipant', taker.info)"
              >Salvar</v-btn
            >
            <v-btn
              v-if="taker.notFound"
              class="jns-button width-auto yellow-button"
              @click="postTaker()"
              :disabled="
                $refs['taker-estrangeiro-form']
                  ? !$refs['taker-estrangeiro-form'].value
                  : false
              "
              >Salvar</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<style lang='scss' scoped>
#jns {
  .box-close-button {
    position: absolute;
    cursor: pointer;
    top: 20px;
    right: 20px;
  }
  .description {
    color: #888;
    font-size: 1.05rem;
  }
  .title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #4e4e4e;
    text-align: center;
  }
  .white-background {
  }
  .text--success {
    color: #4caf50;
  }
  .text--warning {
    color: #ffc107;
  }
  .text--error {
    color: #ff5252;
  }

  .text--primary {
    color: #c2c2c2;
  }
  .close-button {
    float: left;
    margin-top: -35px;
    cursor: pointer;
  }
}
.jns-button {
  text-transform: none;
  margin: 6px 12px;
}
.form-grey-box {
  padding: 25px;
  position: relative;
  width: 100%;
  margin: 12px;
  border-radius: 4px;
  background-color: #f7f7f7;
  font-weight: bold;
}
</style>

<script lang="js">
import { isNumberOrDash, isLetter, capitalize } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "AtualizarSenhaModal",
  mixins: [ViewMixin],
  data: () => ({
    isLetter,
    isNumberOrDash,
    alertText: false,
    showConfirmText: false,
    model: {},
    cnpjErrorModal: false,
    cnpjError: false,
    showSelectTaker: false,
    takerResults: [],
    taker: {
      stepType: 1,
      address: [{}],
    },
    loadingFromBackendModal: false,
    takerFormValid: false,
    rules: {
      required: (v) => !!v || "Este campo é obrigatório!",
    },
  }),

  computed: {
    filteredItems() {},
    takerInfoFullAddress() {
      let t = this;
      if (!t.taker.info) return false;
      let address = t.taker.info.endereco;
      let addressValidInfo = [
        address.logradouro,
        /*address.number, */ address.bairro,
        address.cep,
      ].filter((item) => item);
      let fullAddress =
        addressValidInfo.join(", ") +
        " - " +
        [address.cidade, address.uf].filter((item) => item).join(" - ");
      if (fullAddress == " - ") return "Não Informado";
      return fullAddress;
    },

    progress() {
      if (!this.model.password) return 0;

      if (
        this.model.password.length > 7 &&
        this.model.password.match(
          /(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[\d])/
        )
      ) {
        return 100;
      }

      if (
        this.model.password.length > 7 &&
        this.model.password.match(/(?=.*[a-z])(?=.*[\d])/)
      ) {
        return 50;
      } else {
        return 20;
      }

      // return (this.model.password) ? Math.min(100, this.model.password.length * 10) : 0
    },
    color() {
      if (!this.progress) return "primary";
      return ["error", "warning", "success"][Math.floor(this.progress / 40)];
    },
    textColor() {
      if (!this.progress) return "text--primary";
      return ["text--error", "text--warning", "text--success"][
        Math.floor(this.progress / 40)
      ];
    },
    passwordStrength() {
      if (!this.progress) return "Força d asenha";
      return ["Fraca", "Média", "Forte"][Math.floor(this.progress / 40)];
    },
  },
  methods: {
    selectTakerType(event) {
      let t = this;
      let value = event.currentTarget.value;
      t.taker = {};
      t.taker.stepType = value;
      t.showSelectTaker = false;
      t.takerResults = [];
      t.$forceUpdate();
    },
    async getTakerByCNPJ() {
      let t = this;
      if (!t.taker.cnpj) return;
      let data;
      let cnpj = t.taker.cnpj.replace(/[^\w\s]/gi, "");
      try {
        this.showLoadingAskWait();
        data = await t.$store.dispatch("GET_TAKER_DATA", { cnpj });
      } catch (e) {
        if (e && e[0] && !e[0].ativo) {
          return t.handleInactivePersonError(e[0], "Tomador");
        }
        let type = "taker";
        this.set404ErrorMessage(e, type);
        this.defaultHandlerError(e);
      }
      if (!data) return;
      this.hideLoadingAskWait();
      t.stepCompleted = 1;
      await t.$nextTick();
      t.taker.info = data[0];
      t.taker.found = true;
      t.taker.enderecos = data.enderecos;
      t.$forceUpdate();
    },
    selectTaker(taker) {
      let t = this;
      t.$set(t.taker, "info", taker);
      t.showSelectTaker = false;
      t.$forceUpdate();
    },
    unselectTaker() {
      let t = this;
      t.$set(t.taker, "info", false);
      t.showSelectTaker = true;
      t.$forceUpdate();
    },

    handleInactivePersonError(e, personType) {
      let t = this;
      this.hideLoadingAskWait();
      t.cnpjErrorModal = true;
      t.cnpjError.title = `${personType} Inativo`;
      t.cnpjError.message = `Desculpe, este ${personType} não é compatível com a política da JNS Seguradora.`;
      return;
    },

    async postTaker(options = false) {
      let t = this;
      if (t.stepType == 2) {
        t.$refs["taker-estrangeiro-form"].validate();
        if (!t.takerFormValid) return;
      }
      let taker = Object.assign({}, t.taker);

      let data;

      taker.tipo_pessoa = "PJ_ESTRANGEIRO";

      taker.nome = taker.name;
      taker.endereco = taker.enderecos[0];
      taker.endereco.logradouro = [
        taker.endereco.rua,
        taker.endereco.numero,
        taker.endereco.complemento,
      ].join(", ");
      // taker.tipo_pessoa = options.type
      delete taker.notFound;
      delete taker.enderecos;
      delete taker.stepType;
      delete taker.name;
      delete taker.endereco.rua;
      delete taker.endereco.numero;
      delete taker.endereco.complemento;

      try {
        this.showLoadingAskWait();
        data = await t.$store.dispatch("INSERT_TAKER", taker);
      } catch (e) {
        console.warn(e);
        this.defaultHandlerError(e);
      }

      if (!data) return;
      this.hideLoadingAskWait();
      // t.taker.info = Object.assign(data, {porcentagem: 0})

      await t.$nextTick();
      t.$forceUpdate();
      t.taker = { enderecos: [{}] };
      t.taker.id_participante = t.taker.id;
      t.$emit("addParticipant", Object.assign(data, { porcentagem: 0 }));
    },

    async getTakerByRazaoSocial() {
      let t = this;
      if (!t.taker.name) return;
      let data;
      let name = t.taker.name;
      let personType = "PJ_ESTRANGEIRO";
      try {
        this.showLoadingAskWait();
        data = await t.$store.dispatch("GET_TAKER_DATA_RAZAOSOCIAL", {
          name,
          personType,
        });
      } catch (e) {
        let type = "taker";
        this.set404ErrorMessage(e, type);
        this.defaultHandlerError(e);
        t.taker.notFound = true;
        t.taker.enderecos = [{}];
      }

      this.hideLoadingAskWait();
      await t.$nextTick();
      if (!data) return;
      t.stepCompleted = 1;
      // t.taker.info = data[0]
      t.takerResults = data;
      t.showSelectTaker = true;
      t.taker.found = true;
      t.$forceUpdate();
    },
    close() {
      let t = this;
      t.$emit("close");
      t.taker = {};
      t.taker.stepType = 1;
      setTimeout(() => {
        t.showConfirmText = false;
      }, 1000);
    },

    setDefaultError404Texts() {
      this.cnpjError = {
        title: "Não Encontrado",
        message: "Informação não encontrada",
      };
    },

    set404ErrorMessage(e, type) {
      let person =
        type == "taker" ? "tomador" : type == "insured" ? "segurado" : false;

      let errorMessage = {
        title: `${capitalize(person)} não encontrado`,
        message: `Não foi encontrado nenhum ${person}`,
      };

      if (e.status == 404) {
        e.data = errorMessage;
      }
      return;
    },
  },
  
  props: ["userId"],
};
</script>





// WEBPACK FOOTER //
// ./src/components/AdicionarParticipanteModal.vue